export const DiscrepanciesObjectKeyMap = {
    amount: 'amount',
    rate: 'rate',
    unbilled_amount: 'amount',
    unbilled_quantity: 'quantity',
    unit_price: 'rate',
    unitPrice: 'rate',
    quantity: 'quantity',
};
